/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function AttachmentCloseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_1755_6366" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1755_6366)">
        <path d="M9.99999 10.8784L5.77241 15.106C5.65703 15.2214 5.512 15.2804 5.33732 15.2831C5.16266 15.2857 5.01496 15.2267 4.89424 15.106C4.7735 14.9853 4.71313 14.8389 4.71313 14.6669C4.71313 14.4949 4.7735 14.3485 4.89424 14.2278L9.1218 10.0002L4.89424 5.77265C4.77885 5.65727 4.71982 5.51225 4.71716 5.33757C4.71447 5.1629 4.7735 5.01521 4.89424 4.89448C5.01496 4.77375 5.16132 4.71338 5.33332 4.71338C5.50532 4.71338 5.65168 4.77375 5.77241 4.89448L9.99999 9.12205L14.2276 4.89448C14.3429 4.77909 14.488 4.72007 14.6627 4.7174C14.8373 4.71472 14.985 4.77375 15.1057 4.89448C15.2265 5.01521 15.2868 5.16157 15.2868 5.33357C15.2868 5.50557 15.2265 5.65193 15.1057 5.77265L10.8782 10.0002L15.1057 14.2278C15.2211 14.3432 15.2802 14.4882 15.2828 14.6629C15.2855 14.8376 15.2265 14.9853 15.1057 15.106C14.985 15.2267 14.8387 15.2871 14.6667 15.2871C14.4947 15.2871 14.3483 15.2267 14.2276 15.106L9.99999 10.8784Z" fill="currentColor" />
      </g>
    </svg>
  );
}

export default AttachmentCloseIcon;
